<template>
	<v-container fluid id="profil-page-routers">
		<v-row>
			<v-col cols="12" class="text size-large weight-bold font-alt">
				Mettez à jour vos informations
			</v-col>
		</v-row>
		<v-row v-if="!applicationReady">
			<v-col cols="12" class="">
				Loading ...
			</v-col>
		</v-row>
	
			<v-row v-if="applicationReady && router.length === 0" class="no_router_bloc justify-center align-center">
				<v-col cols="6" md="4">
					<p class="no_router">Aucun router configuré.</p>
				</v-col>
			</v-row>
		<v-row v-if="applicationReady" class="px-3 mt-8">
			<v-row	
				class="colored-bg d-flex flex-row "
				:class="{
					'px-0' : $vuetify.breakpoint.md,
					'px-15' : $vuetify.breakpoint.lg,
				}"
			>
				<v-col cols="12">
					<div class="text-center text size-large font-weight-bold">{{ routerTitle }}</div>
				</v-col>
				<v-col class="col"></v-col>
				<v-col cols="11">
					<v-card 
						class="theme-card rounded pt-5 pb-5 mb-14"
					>
						<v-row justify="space-around">
							<routers-card 
								v-for="(box, index) in router" :key="index" 
								:headerTitle="box.name"
								:title="box.establishment_name"
								:subtitle="box.address"
							/>
						</v-row>
						<v-row 
							justify="center"
							class="card-btn mt-8"
							:class="{
								 'pt-10': nbRouters === 1,
								 'pt-15 pr-5': nbRouters > 1,
								}"
						>
							<customButton
								class="mr-1"
								label="COMMANDER MA BOX"
								btnType="order"
								@click="onClickOutsideIsActive = true"
							/>
							<v-dialog
								v-click-outside="onClickOutside"
								v-model="dialog"
								class="Dialog-content ml-8 theme-dialog"
								hide-overlay	
								max-width="600px"
							>
								<template v-slot:activator="{ on }">
									<customButton 
										v-on="on"
										class="ml-1"
										label="INSTALLER MA BOX"
										btnType="install"
										@click="openDialog"
									/>
								</template>
								<v-card-text>
									<v-container>
										<v-col>
											<v-row justify="center">
												<p class="text weight-bold modal-title pt-10" >Renseignez la MAC Adresse de votre Box :</p>
											</v-row>
											<v-row justify="center">
												<TextInput 
													outlined
													:v-model="macAddress"
													@input="update"
													v-if="!showRouterLoader && !routerIsAdded && !routerAddingError"
													placeholder="Exemple de numéro : 00-BO-DO-86-BB-F7"
												/>
												<loader v-if="showRouterLoader" />
												<v-col v-else-if="!showRouterLoader && routerIsAdded">
													<v-row justify="center">
														 <v-icon 
															class="check-circle material-icons"
															size="34"
														>
															check_circle
														</v-icon>
													</v-row>
													<v-row justify="center">
														<p class="added-router text weight-bold pt-1">La Box est ajoutée !</p>
													</v-row>
												</v-col>
												<v-col v-else-if="routerAddingError">
													<v-row justify="center">
														 <v-icon 
															class="warning_amber material-icons-round"
															size="34"
														>
															warning_amber
														</v-icon>
													</v-row>
													<v-row justify="center">
														<p class="error-adding-router text weight-bold pt-1">La MAC Adresse est incorrecte</p>
													</v-row>
												</v-col>
											</v-row>
											<v-row
												class="pt-5 pb-5" 
												justify="center"
											>
												<v-col cols="6">
													<customButton 
														:isDisabled="cancelBtnIsDisabled"
														label="ANNULER"
														btnType="cancel"
														labelColor="grey"
														:elevation="0"
														@click="closeDialog"
													/>
												</v-col>
												<v-col cols="6">
													<customButton 
														:isDisabled="validateBtnIsDisabled"
														@click="addRouter(macAddress)"
														label="VALIDER"
														btnType="order"
													/>
												</v-col>
											</v-row>
										</v-col>	
									</v-container>
								</v-card-text>
							</v-dialog>
						</v-row>
					</v-card>
				</v-col>
				<v-col class="col"></v-col>
			</v-row>
		</v-row>
	</v-container>
</template>

<script type="text/javascript">
import RoutersCard from '../../../components/ui/routers-card.vue'
import customButton from '@/components/buttons/customButton.vue'
import TextInput from '@/components/input/textInput.vue'
import loader from '@/components/ui/loader.vue'

  export default {
    components: {
		RoutersCard,
		customButton,
		TextInput, 
		loader
    },
    props: {},
    data() {
		return {
			macAddress: '',
			nbRouters: 0,
			onClickOutsideIsActive: false,
            routerAddingError: false,
            cancelBtnIsDisabled: false,
            validateBtnIsDisabled: false,
        }
    },
	created() {
		this.$store.dispatch('routers/routerData');
		this.nbRouters = this.$store.state.routers.routers.length;

		this.routerAddingError = this.$store.state.routers.routers.routerAddError;
	},
	methods : {
		update(macValue) {
			this.macAddress = macValue;
		},
		openDialog(){
			this.$store.commit('routers/setRouterDialog', true, { root:true});
		},
		closeDialog(){
			this.$store.commit('routers/setRouterDialog', false, { root:true});
			this.$store.commit('routers/setLoaderStatus', false, { root:true});
		},
		addRouter(mac) {
			var  newRouter= 
				{
					boxReference: mac,
				};
			this.$store.dispatch('routers/addRouter', newRouter);
		},
		onClickOutside () {
			if(this.onClickOutsideIsActive){
				this.onClickOutsideIsActive = false;
			}
        },
	},
	computed: {
		applicationReady(){
			return this.$store.state.routers.routers.isReady;
		},
		router() {
			return this.$store.state.routers.routers.value;
		},
		showRouterLoader(){
			return this.$store.state.routers.routers.loaded;
		},
		routerIsAdded(){
			return this.$store.state.routers.routers.routerIsAdd;
		},
		dialog(){
			return this.$store.state.routers.routers.dialog;
		},
		routerTitle() {
			if(this.nbRouters > 1){return 'État de mes Box';}
			else{return 'État de ma Box';}
		},
	},
  }
</script>

<style lang="scss">
  	.Dialog-content {
      	border: 1px solid black !important;
	}
	.no_router {
		text-align: center;
	}
	.no_router_bloc {
		text-align: center;
		// padding-top: 20%;
	}
	.modal-title {
		color: $purple-alt !important;
	}
	.added-router, .check-circle {
		color: $green-button !important;
	} 
	.error-adding-router, .warning_amber {
		color: $orange-router !important;
	}
	#profil-page-routers {
		.card-btn {
            padding-bottom: 13.5em;
        }
	
	}
</style>
